import { Link } from "react-router-dom";
import { NAV } from "../lib/nav";

// Cards derive from the single NAV source so the dashboard and sidebar can never
// drift out of sync.
const CARDS = NAV;

export default function Home() {
  return (
    <div>
      <h1 className="text-xl font-semibold">Surround Admin</h1>
      <p className="mt-1 text-sm text-zinc-400">
        Operator + agent console for the Surround platform.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {CARDS.map((c) => (
          <Link
            key={c.href}
            to={c.href}
            className="rounded-lg border border-zinc-800 bg-zinc-950 p-4 hover:border-zinc-700"
          >
            <div className="font-medium">{c.label}</div>
            <div className="mt-1 text-sm text-zinc-400">{c.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
